import { useState } from 'react';
import styles from './UsuarioModal.module.css';

const PERFIS = [
  {
    valor: 'Gestor',
    titulo: 'Gestor',
    desc: 'Acesso total ao sistema, incluindo cadastros e configurações.',
  },
  {
    valor: 'Operador',
    titulo: 'Operador',
    desc: 'Movimentações e consultas. Sem acesso a cadastros.',
  },
  {
    valor: 'Visualizador',
    titulo: 'Visualizador',
    desc: 'Somente leitura. Não pode criar nem editar.',
  },
];

function validarEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default function UsuarioModal({ usuario, onSalvar, onCancelar, salvando }) {
  const editando = !!usuario;

  const [nome, setNome] = useState(usuario?.nome || '');
  const [email, setEmail] = useState(usuario?.email || '');
  const [telefone, setTelefone] = useState(usuario?.telefone || '');
  const [cargo, setCargo] = useState(usuario?.cargo || '');
  const [perfil, setPerfil] = useState(usuario?.perfil || 'Operador');
  const [ativo, setAtivo] = useState(usuario?.ativo ?? true);
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');

  const valido =
    nome.trim().length >= 2 &&
    email.trim().length > 0 &&
    validarEmail(email.trim()) &&
    perfil.length > 0 &&
    (editando || (senha.length >= 6 && senha === confirmarSenha));

  function handleSalvar() {
    if (!valido) {
      if (!validarEmail(email.trim())) {
        alert('Email inválido. Use um formato como nome@exemplo.com');
      } else if (!editando && senha.length < 6) {
        alert('A senha deve ter ao menos 6 caracteres.');
      } else if (!editando && senha !== confirmarSenha) {
        alert('As senhas não conferem.');
      } else {
        alert('Preencha todos os campos obrigatórios (marcados com *).');
      }
      return;
    }
    const payload = {
      nome: nome.trim(),
      email: email.trim().toLowerCase(),
      telefone: telefone.trim(),
      cargo: cargo.trim(),
      perfil,
      ativo,
    };
    if (!editando) payload.senha = senha;
    onSalvar(payload);
  }

  return (
    <div className={`${styles.modalOverlay} ${styles.aberto}`}>
      <div className={styles.modal}>
        <div className={styles.modalHead}>
          <div>
            <div className={styles.modalTitle}>
              {editando ? 'Editar usuário' : 'Novo usuário'}
            </div>
            <div className={styles.modalSubtitle}>
              {editando
                ? 'Atualize os dados do usuário.'
                : 'Preencha os dados. A conta Firebase Auth será criada automaticamente.'}
            </div>
          </div>
          <button className={styles.modalClose} onClick={onCancelar}>
            ✕
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Identificação</div>
            <div className={styles.formGrid}>
              <div className={`${styles.formField} ${styles.full}`}>
                <label className={styles.formLabel}>
                  Nome completo <span className={styles.obrigatorio}>*</span>
                </label>
                <input
                  className={styles.formInput}
                  placeholder="Ex: Carlos Silva"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                />
              </div>
              <div className={styles.formField}>
                <label className={styles.formLabel}>
                  Email <span className={styles.obrigatorio}>*</span>
                </label>
                <input
                  className={styles.formInput}
                  type="email"
                  placeholder="exemplo@jatear.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={editando}
                />
                <div className={styles.formHint}>
                  {editando
                    ? 'Email não pode ser alterado após cadastro.'
                    : 'Será usado para login no sistema.'}
                </div>
              </div>
              <div className={styles.formField}>
                <label className={styles.formLabel}>Telefone</label>
                <input
                  className={styles.formInput}
                  placeholder="(31) 9 9999-9999"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                />
              </div>
              <div className={`${styles.formField} ${styles.full}`}>
                <label className={styles.formLabel}>Cargo / Função</label>
                <input
                  className={styles.formInput}
                  placeholder="Ex: Almoxarife (opcional)"
                  value={cargo}
                  onChange={(e) => setCargo(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>
              Perfil de acesso <span className={styles.obrigatorio}>*</span>
            </div>
            <div className={styles.perfisGrid}>
              {PERFIS.map((p) => (
                <div
                  key={p.valor}
                  className={`${styles.perfilCard} ${perfil === p.valor ? styles.selecionado : ''}`}
                  onClick={() => setPerfil(p.valor)}
                >
                  <div className={styles.perfilCardTitulo}>{p.titulo}</div>
                  <div className={styles.perfilCardDesc}>{p.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Status</div>
            <div className={styles.toggleStatus}>
              <div
                className={`${styles.toggleSwitch} ${ativo ? styles.ativo : ''}`}
                onClick={() => setAtivo(!ativo)}
              />
              <div className={styles.toggleLabel}>
                Usuário {ativo ? 'ativo' : 'inativo'}
                <small>
                  Usuários inativos não conseguem fazer login no sistema.
                </small>
              </div>
            </div>
          </div>

          {!editando && (
            <div className={styles.formSection}>
              <div className={styles.formSectionTitle}>
                Senha de acesso <span className={styles.obrigatorio}>*</span>
              </div>
              <div className={styles.formGrid}>
                <div className={styles.formField}>
                  <label className={styles.formLabel}>
                    Senha <span className={styles.obrigatorio}>*</span>
                  </label>
                  <input
                    className={styles.formInput}
                    type="password"
                    placeholder="Mínimo 6 caracteres"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  />
                </div>
                <div className={styles.formField}>
                  <label className={styles.formLabel}>
                    Confirmar senha <span className={styles.obrigatorio}>*</span>
                  </label>
                  <input
                    className={styles.formInput}
                    type="password"
                    placeholder="Repita a senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                  />
                  {senha && confirmarSenha && senha !== confirmarSenha && (
                    <div className={styles.formHint} style={{ color: '#b51013' }}>
                      ⚠ As senhas não conferem.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={styles.modalFoot}>
          <button className={styles.btnSecondary} onClick={onCancelar}>
            Cancelar
          </button>
          <button
            className={styles.btnPrimary}
            onClick={handleSalvar}
            disabled={!valido || salvando}
          >
            {salvando
              ? 'Salvando...'
              : editando
              ? 'Salvar alterações'
              : 'Cadastrar usuário'}
          </button>
        </div>
      </div>
    </div>
  );
}